import Vue from 'vue'
import App from '@/App.vue'
import store from '@/store'
import _ from 'lodash'
import '@/core/prototype-modifications'
import '@/core/startup/global-registrations'
import '@/assets/styles/main.scss'
import { loadClientModel } from '@/core/startup/client-model-loader'
import '@/core/startup/request-monitor'
import VModal from 'vue-js-modal'
import Default from '@/layouts/default.vue'
import Checkout from '@/layouts/checkout.vue'
import Information from '@/layouts/information.vue'
import { registerVeeValidation } from '@/core/startup/vendor/register-vee-validation'
import '@/core/startup/vendor/carbon-icons'
import { elementReady } from '@/core/startup/element-ready'
import VueScrollTo from 'vue-scrollto'
import 'url-search-params-polyfill'
import mockService from '@/core/mock-service'
import VueObserveVisibility from 'vue-observe-visibility'
import VScrollLock from 'v-scroll-lock'
import VToolTip from 'v-tooltip'
import { addApplicationInsight } from '@/core/ai'
import PortalVue from 'portal-vue'
import { showComplementUserDetailsModal } from '@/core/modal-service'

const clientModel = loadClientModel()
addApplicationInsight(clientModel.instrumentationKey)

registerVeeValidation()
store.dispatch('subscribeToResponsiveEvents')
store.dispatch('commerce/getCart', clientModel.cartType)

Vue.use(VToolTip, {
  defaultPlacement: 'bottom'
})
Vue.use(VScrollLock)
Vue.use(VModal)

Vue.use(VueScrollTo, {
  container: 'body',
  offset: -100
})

Vue.use(VueObserveVisibility)
Vue.use(PortalVue)

Vue.component('default-layout', Default)
Vue.component('checkout-layout', Checkout)
Vue.component('information-layout', Information)

Vue.config.productionTip = false

const vueOptions = { store,
  mounted() {
    if(clientModel.isAuthenticated) {
      showComplementUserDetailsModal()
      store.dispatch('myMachines/getMyMachines').then(() => {
        store.dispatch('myMachines/askToSetGlobalMachineSelection')
      })
      store.dispatch('myMachines/getVehicles')
      store.dispatch('myMachines/getMyMachinesMetaData')
    }
  } }

if(process.env.VUE_APP_TYPE === 'spa') {
  const router = require('@/router')
  _.assignIn(vueOptions, { router: router.default || router, render: h => h(App) })
}

const mountVue = () => {
  elementReady('#app').then(() => {
    new Vue(vueOptions).$mount('#app')
  })
}

if(process.env.VUE_APP_TYPE === 'spa') {
  if (process.env.VUE_APP_SIGN_IN) {
    mockService.tryLoginTestUser().then(mountVue)
  } else {
    mountVue()
  }
} else {
  new Vue(vueOptions).$mount('#app')
}
